export const getPercentValue = (size: number): string => {
  return `${Math.min(100, size * 100)}%`
}
